import { KalTableEventManager } from './kal-table-event-manager';

export class KalTableFiltersManager extends KalTableEventManager<any> {

}
